import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import {PtrnCampoEditableBoolean} from '../../../patronTypes';
import {EditableProps} from '../campoEditableTypes';
import {useInputStyles} from '../campoEditableUtils';
import {PtrnPropsUtil} from '../../../patronUtils';

function CampoEditableCheckbox(
   props: {campoConfig: PtrnCampoEditableBoolean} & EditableProps & {
         ErrorComponent?: React.ReactNode;
      }
) {
   const {campoConfig, ...editableProps} = props;
   const classes = useInputStyles();

   const auxParam = {
      camposData: editableProps.camposData,
      campoConfig: campoConfig,
      ptrnRef: editableProps.ptrnRef,
      ruta: editableProps.ruta,
      index: editableProps.index
   };

   const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      const name = e.target.name;
      let newValue = e.target.checked;
      editableProps.onChange(name, newValue, auxParam);
   };

   //#region GEN PROPS
   const id = PtrnPropsUtil.genIdCampoEditable(campoConfig);
   const endAdornments = props.ErrorComponent ? (
      <InputAdornment position="end">{props.ErrorComponent}</InputAdornment>
   ) : undefined;
   //#endregion

   //#region RETORNOS

   return (
      <FormControlLabel
         label={campoConfig.label}
         control={
            <Checkbox
               className={classes.classes.ceFocused}
               sx={{p: Boolean(campoConfig.noPadding) ? 0 : undefined}}
               id={id}
               name={campoConfig.name}
               checked={Boolean(editableProps.value)}
               onChange={handleOnChange}
               color={
                  campoConfig.color as
                     | 'primary'
                     | 'secondary'
                     | 'error'
                     | 'info'
                     | 'success'
                     | 'warning'
                     | 'default'
               }
            />
         }
      />
   );
   //#endregion
}

export default CampoEditableCheckbox;
